import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { ProjectSchedulesService } from "@/modules/projects/service/projectSchedule";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useProjectSchedulesContext } from "../ProjectSchedulesContext";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";

export const useCancelScheduleVisitMutation = (
  scheduleId: string,
  visitId: string,
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { projectId, refetch } = useProjectSchedulesContext();

  return useMutationWithErrorHandling({
    mutationFn: () =>
      ProjectSchedulesService.cancelVisit(projectId, scheduleId, visitId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.ProjectSchedules],
      });
      refetch();
      toast({
        title: t("projectContractorVisits.success.cancel"),
      });
    },
    errorTitle: t("projectContractorVisits.errors.cancel"),
  });
};
